import customAxios from '@Utils/Axios';

const getIs2033User = async () => {
  const response = await customAxios.get('/is2033User');

  return response;
};

const createAuthor = async nickname => {
  const response = await customAxios.post('/author', { nickName: nickname });

  return response;
};

const getAuthor = async () => {
  const response = await customAxios.get('/author');

  return response;
};

const postProfileImageId = async profileImageId => {
  await customAxios.post('/author_profile', { profileImageId });
};

const isTester = async () => {
  const response = await customAxios.get('/isTester');
  return response;
};

const isBetaTester = async () => {
  const response = await customAxios.get('/isBetaTester');
  return response;
};

export { getIs2033User, createAuthor, getAuthor, postProfileImageId, isTester, isBetaTester };
